import { IconShape, IconPackOption } from "@nova/constants"
import * as Icons from "@nova/component-icons"
import {
    BCWSIconPack,
    FireAIIconPack,
    ForestryIconPack,
    IconPack,
    NFPAEmergencyPack,
    NFPAFireServicePack,
    NFPAGeneralUsePack,
    NumberPack,
    NWCGIconPack,
    SarcopIconPack,
} from "@nova/component-map-icons/src/icon-packs"

export const iconByShape: Record<IconShape, Icons.IconComponent> = {
    [IconShape.Circle]: Icons.Circle,
    [IconShape.Square]: Icons.Square,
    [IconShape.Triangle]: Icons.Triangle,
    [IconShape.Star]: Icons.StarShape,
    [IconShape.Kite]: Icons.Diamond,
    [IconShape.Plus]: Icons.Cross,
}

export const shapeIcons: [IconShape, Icons.IconComponent][] = Object.entries(iconByShape).map(
    ([shape, Icon]) => [shape as IconShape, Icon]
)

const iconPackPrefixMap = {
    numbers: IconPackOption.Number,
    nwcg: IconPackOption.NWCG,
    nfpa_emergency_operations: IconPackOption.NFPAEmergency,
    nfpa_emergency_incidents_symbology: IconPackOption.NFPAEmergency,
    nfpa_emergency_natural_events_symbology: IconPackOption.NFPAEmergency,
    nfpa_general_use: IconPackOption.NFPAGeneralUse,
    nfpa_fire_service: IconPackOption.NFPAFireService,
    sarcop: IconPackOption.SARCOP,
    sarcrop_search_human_interactions_that_need_follow_up_by_default: IconPackOption.SARCOP,
    bcws: IconPackOption.BCWS,
    forestry: IconPackOption.Forestry,
    fireai: IconPackOption.FireAI,
}
export const iconPackByPrefix = Object.entries(iconPackPrefixMap)

export const iconsByIconPack: Record<Exclude<IconPackOption, "Shape">, IconPack> = {
    [IconPackOption.Number]: { Numbers: NumberPack },
    [IconPackOption.NWCG]: NWCGIconPack,
    [IconPackOption.NFPAEmergency]: NFPAEmergencyPack,
    [IconPackOption.NFPAFireService]: NFPAFireServicePack,
    [IconPackOption.NFPAGeneralUse]: NFPAGeneralUsePack,
    [IconPackOption.SARCOP]: SarcopIconPack,
    [IconPackOption.BCWS]: BCWSIconPack,
    [IconPackOption.Forestry]: ForestryIconPack,
    [IconPackOption.FireAI]: FireAIIconPack,
}
